import Config    from '../../../State/Stores/Config/Config';
import LoadError from '../Constants/LoadError';

import requestLicense from './requestLicense';

/**
 * Authenticates a provided FairPlay session by providing it with a
 * FairPlay license in response to key message value emitted from
 * the session.
 */

const authenticateSession = (session: any, config: Config): Promise<void> =>
    new Promise<Uint8Array>((resolve, reject) => {
        session.onwebkitkeymessage = e =>
            requestLicense(e.message, config)
                .then(resolve, reject);

        session.onwebkitkeyerror = () => reject(new Error(LoadError.WEBKIT_KEY_ERROR));
    })
        .then(license => {
            if (!(license instanceof Uint8Array)) throw new TypeError(LoadError.INVALID_LICENSE);

            session.update(license);
        });

export default authenticateSession;